import React, { Component } from 'react';
import { IUserMedal } from '@umu/umu-types';
import { classSet } from '@umu/umu-dom';
import { openWindow, unescapeHtml } from '@umu/umu-util';
import { components } from 'common';
const { If } = components;

import UserMedalIcon from '../userMedalIcon/userMedalIcon';
import './userName.scss';
import { goUserProfile } from '../../../services';

export interface IProps {
    id?: string;
    className: string;
    name: string;
    userMedalInfo?: IUserMedal;
    showUserLevel?: number;
    userMedalWidth?: 20 | 30 | 16;
    transcate?: boolean;
    href?: string;
    isToProfile?: boolean;
    isStudentId?: boolean;
    isLogin?: boolean;
    onClick?: () => void;
}

export default class UserName extends Component<IProps> {
    public render() {
        const {
            id,
            name,
            className,
            isToProfile,
            showUserLevel,
            userMedalInfo,
            userMedalWidth = 20,
            transcate,
            href,
            isStudentId = true,
            isLogin = true,
            onClick,
        } = this.props;
        const userMedalHolderWidth = userMedalWidth ? ' width-' + userMedalWidth : '';
        const showMedal = !!showUserLevel && !!userMedalInfo && !!userMedalInfo.medal_type;
        const transcateCls = transcate && showUserLevel && userMedalInfo ? 'transcate' + userMedalHolderWidth : '';

        const cursor = (!!href || isToProfile) && isLogin ? 'cursor' : '';
        const medalCls = showMedal ? '' : 'hide-medal';

        const goHome = () => {
            if (onClick) {
                onClick();
            }

            if (isToProfile && id) {
                goUserProfile(id, isStudentId);
                return;
            }
            if (!href) {
                return;
            }
            openWindow(href, '_blank');
        };

        return (
            <div
                className={classSet('user-name-info is-mobile', className, transcateCls, cursor, medalCls)}
                onClick={goHome}
            >
                <span className="user-name-content">{unescapeHtml(name)}</span>
                <If condition={showMedal}>
                    <div className={'user-medal-info-holder' + userMedalHolderWidth}>
                        <UserMedalIcon userMedalInfo={userMedalInfo} userMedalWidth={userMedalWidth} />
                    </div>
                </If>
            </div>
        );
    }
}
